import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { IDLE, PENDING } from "const"
import { deepCopy, StateType } from "client/utils"
import {
    StoreType,
    DisplayColumns,
    showCcComplianceColumnSettings,
    updateUserSettings,
    setSystemUserSettings,
    SaveUserSettings,
} from "client/store"
import {
    ConfirmWrapper,
    Confirm,
    ConfirmTitle,
    ConfirmBottom,
    CheckButton,
    Button,
    SpinnerIcon,
    TableColumn,
} from "client/components"


interface DisplayColumnsProps {
    columns: TableColumn[]
    displayColumns: DisplayColumns
}

const DisplayComplianceColumns = ({
    columns,
    displayColumns,
}: DisplayColumnsProps) => {
    const showColumnSettings = useSelector((state: StoreType) => state.ccCompliance.showColumnSettings)
    const settings = useSelector((state: StoreType) => state.userSettings.settings)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [saveState, setSaveState] = useState<StateType>(IDLE)

    const complianceColumns = settings.displayColumns.compliance

    useEffect(() => {
        setDisplayColumns(displayColumns)
    }, [showColumnSettings])

    const setDisplayColumns = (value: DisplayColumns) => {
        dispatch(updateUserSettings(
            "displayColumns",
            { compliance: value },
        ))
    }

    const onCancel = () => {
        dispatch(showCcComplianceColumnSettings(false))
    }

    const onChange = (columnId: string) => {
        const newColumns = deepCopy(complianceColumns)
        if (newColumns[columnId]) newColumns[columnId] = false
        else newColumns[columnId] = true

        setDisplayColumns(newColumns)
    }

    const onConfirm = () => {
        setSaveState(PENDING)
        SaveUserSettings(userData.userId, userData.accountId, settings)
        .then(() => {
            setSaveState(IDLE)
            dispatch(setSystemUserSettings(settings))
            dispatch(showCcComplianceColumnSettings(false))
        })
    }

    const maxColumnLength = columns.length > 4
        ? columns.length / 2 + (columns.length % 2)
        : columns.length

    const columns1 = columns.slice(0, maxColumnLength)
    const columns2 = columns.slice(maxColumnLength)

    return (
        <ConfirmWrapper
            show={showColumnSettings}
            onClose={onCancel}
        >
            <Confirm>
                <ConfirmTitle>{lang.selectColumns}</ConfirmTitle>

                <Row>
                    <Col xs={6}>
                        {
                            columns1.map((column) => (
                                <CheckButton
                                    key={column.field}
                                    title={column.header}
                                    checked={complianceColumns[column.field]}
                                    onChange={() => onChange(column.field)}
                                />
                            ))
                        }
                    </Col>
                    <Col xs={6}>
                        {
                            columns2.map((column) => (
                                <CheckButton
                                    key={column.field}
                                    title={column.header}
                                    checked={complianceColumns[column.field]}
                                    onChange={() => onChange(column.field)}
                                />
                            ))
                        }
                    </Col>
                </Row>

                <ConfirmBottom>
                    <Button row onClick={onCancel}>{lang.cancel}</Button>
                    <Button variant="success" row onClick={onConfirm}>
                        {saveState === PENDING ? <SpinnerIcon /> : lang.confirm}
                    </Button>
                </ConfirmBottom>
            </Confirm>
        </ConfirmWrapper>
    )
}
export default DisplayComplianceColumns
